module.exports = __webpack_public_path__ + "img/logo.8b33de2d.svg";